module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_11.f7e130a8.png";